import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_34: FaireProductEntity = {
  token: "starter_collection_34",
  type: "product",
  name: "'The Almost 4\" Knife'",
  brandName: "Material",
  imageUrl: "",
  priceDollars: 75,
  msrpDollars: 150,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
